import { combineReducers } from 'redux';
import {
  FETCH_SUBSCRIPTION_PLANS_REQUEST,
  FETCH_SUBSCRIPTION_PLANS_SUCCESS,
  FETCH_SUBSCRIPTION_PLANS_FAILURE,
  FETCH_SUBSCRIPTION_COUPONS_REQUEST,
  FETCH_SUBSCRIPTION_COUPONS_SUCCESS,
  FETCH_SUBSCRIPTION_COUPONS_FAILURE,
  FETCH_CHECKOUT_PREVIEW_REQUEST,
  FETCH_CHECKOUT_PREVIEW_SUCCESS,
  FETCH_CHECKOUT_PREVIEW_FAILURE,
  CLEAR_CHECKOUT_PREVIEW,
  FETCH_CHECKOUT_EDIT_PREVIEW_REQUEST,
  FETCH_CHECKOUT_EDIT_PREVIEW_SUCCESS,
  FETCH_CHECKOUT_EDIT_PREVIEW_FAILURE,
  CLEAR_CHECKOUT_EDIT_PREVIEW,
  FETCH_CHECKOUT_EDIT_PREVIEW_ONLY_IMMEDIATE_REQUEST,
  FETCH_CHECKOUT_EDIT_PREVIEW_ONLY_IMMEDIATE_SUCCESS,
  FETCH_CHECKOUT_EDIT_PREVIEW_ONLY_IMMEDIATE_FAILURE,
} from '../constants/ActionTypes';

const plans = (
  state = { data: [], isFetching: false, errorMessage: null },
  action
) => {
  switch (action.type) {
    case FETCH_SUBSCRIPTION_PLANS_REQUEST:
      return { ...state, isFetching: true, errorMessage: null };
    case FETCH_SUBSCRIPTION_PLANS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: action.data.data,
      };
    case FETCH_SUBSCRIPTION_PLANS_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.message };
    default:
      return state;
  }
};

const coupons = (
  state = { data: [], isFetching: false, errorMessage: null },
  action
) => {
  switch (action.type) {
    case FETCH_SUBSCRIPTION_COUPONS_REQUEST:
      return { ...state, isFetching: true, errorMessage: null };
    case FETCH_SUBSCRIPTION_COUPONS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: action.data.data,
      };
    case FETCH_SUBSCRIPTION_COUPONS_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.message };
    default:
      return state;
  }
};

const checkoutPreview = (
  state = { data: {}, isFetching: false, errorMessage: null },
  action
) => {
  switch (action.type) {
    case FETCH_CHECKOUT_PREVIEW_REQUEST:
      return { ...state, isFetching: true, errorMessage: null };
    case FETCH_CHECKOUT_PREVIEW_SUCCESS:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: action.data.data,
      };
    case FETCH_CHECKOUT_PREVIEW_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.message };
    case CLEAR_CHECKOUT_PREVIEW:
      return { data: {}, isFetching: false, errorMessage: null };
    default:
      return state;
  }
};

const checkoutEditPreview = (
  state = { data: {}, isFetching: false, errorMessage: null },
  action
) => {
  switch (action.type) {
    case FETCH_CHECKOUT_EDIT_PREVIEW_REQUEST:
      return { ...state, isFetching: true, errorMessage: null };
    case FETCH_CHECKOUT_EDIT_PREVIEW_SUCCESS:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: action.data.data,
      };
    case FETCH_CHECKOUT_EDIT_PREVIEW_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.message };
    case CLEAR_CHECKOUT_EDIT_PREVIEW:
      return { data: {}, isFetching: false, errorMessage: null };
    default:
      return state;
  }
};

const checkoutEditPreviewOnlyImmediate = (
  state = { data: {}, isFetching: false, errorMessage: null },
  action
) => {
  switch (action.type) {
    case FETCH_CHECKOUT_EDIT_PREVIEW_ONLY_IMMEDIATE_REQUEST:
      return { ...state, isFetching: true, errorMessage: null };
    case FETCH_CHECKOUT_EDIT_PREVIEW_ONLY_IMMEDIATE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: action.data.data,
      };
    case FETCH_CHECKOUT_EDIT_PREVIEW_ONLY_IMMEDIATE_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.message };
    case CLEAR_CHECKOUT_EDIT_PREVIEW:
      return { data: {}, isFetching: false, errorMessage: null };
    default:
      return state;
  }
};

const subscription = combineReducers({
  plans,
  coupons,
  checkoutPreview,
  checkoutEditPreview,
  checkoutEditPreviewOnlyImmediate,
});

export default subscription;
